import styled from '@emotion/styled'
import React from 'react'
import { reExportedColors } from '../../index'

export default function ToggleButton ({ isSwitch, setSwitch }) {
  const googlePull = async () => {
    setSwitch(!isSwitch)
  }

  const enableColor = isSwitch ? reExportedColors.RED : reExportedColors.TEXT_BOLD
  const circleLeft = isSwitch ? '-11px' : '11px'
  const circleColor = isSwitch ? reExportedColors.RED : reExportedColors.MEDIUM_GREY
  const disableColor = !isSwitch ? reExportedColors.RED : reExportedColors.TEXT_BOLD

  return (
    <Cont>
      <Enable color={enableColor}>Enable</Enable>
      <SwitchCont onClick={googlePull}>
        <Circle left={circleLeft} circleColor={circleColor} />
      </SwitchCont>
      <Disable disableColor={disableColor}>Disable</Disable>
    </Cont>
  )
}

const Cont = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
})

const SwitchCont = styled.div({
  width: '50px',
  height: '25px',
  borderRadius: '50px',
  backgroundColor: `${reExportedColors.WHITE}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'black 1px solid'
})

const Enable = styled.p({
  fontSize: '14px',
  margin: 0,
  paddingRight: 5
}, (props) => ({
  color: props.color
}))

const Disable = styled.p({
  fontSize: '14px',
  margin: 0,
  paddingLeft: 5
}, (props) => ({
  color: props.disableColor
}))

const Circle = styled.div({
  position: 'relative',
  width: 20,
  height: 20,
  borderRadius: '50%',
  transition: 'left 0.3s'
}, (props) => ({
  left: props.left,
  backgroundColor: props.circleColor
}))
